module.exports = __webpack_public_path__ + "img/vertical_bar_chart.ef8cf2d8.svg";